export const LESSEON_PLAN_OPTIONS_VOCABULARY_REQUEST = 'LESSEON_PLAN_OPTIONS_VOCABULARY_REQUEST';
export const LESSEON_PLAN_OPTIONS_VOCABULARY_SUCCESS = 'LESSEON_PLAN_OPTIONS_VOCABULARY_SUCCESS';
export const LESSEON_PLAN_OPTIONS_VOCABULARY_FAILURE = 'LESSEON_PLAN_OPTIONS_VOCABULARY_FAILURE';
